import { Tag } from "antd";

export const ErrorTag = ({ icon, text = null }) => {
  return (
    <Tag color="red-inverse">
      {icon} {text === null ? "Error" : text}
    </Tag>
  );
};
